<template>
  <div id="deviceManagement">
    <div class="title">设备管理</div>
    <div class="content_1">
      <div class="yali">
        <div class="font_icon">
          <p>58</p>
          <p class="yali_font">个</p>
        </div>
        <p class="yali_2">阀门</p>
      </div>
      <div class="shuibiao">
        <div class="font_icon">
          <p>26</p>
          <p class="yali_font">套</p>
        </div>
        <p class="yali_2">水表</p>
      </div>
    </div>

    <div class="content_1">
      <div class="famen">
        <div class="font_icon">
          <p>{{$store.state.pressdata | pressNumFilter}}</p>
          <p class="yali_font">个</p>
        </div>
        <p class="yali_2">压力计</p>
      </div>

      <div class="xiaofang">
        <div class="font_icon">
          <p>13</p>
          <p class="yali_font">套</p>
        </div>
        <p class="yali_2">室外消防栓</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      
    }
  },
  filters:{
    pressNumFilter(item){
      return item.length
    }
  }
  
}
</script>

<style scoped>
#deviceManagement{
    width: 100%;
    margin-top: 1.94vh;
    height: 17.87vh;
    background: url("@/assets/pengshui_bg.png") no-repeat center center;
    color: #ffffff;
    background-size: 100% 100%;
}
.title{
  height: 4.53vh;
  font-size: 18px;
  line-height: 4.53vh;
  text-align: start;
  margin-left: 20px;
}
.content_1{
  height: 5.64vh;
  width: 95%;
  display: flex;
  justify-content: space-around;
  margin-top: 0.56vh;
}
.yali{
  width: 48%;
  height: 100%;
  background: url("@/assets/pengshui_20.png") no-repeat center center;
  background-size: 100% 100%;
  text-align: start;
}
.shuibiao{
  width: 48%;
  background: url("@/assets/pengshui_21.png") no-repeat center center;
  background-size: 100% 100%;
  text-align: start;
}
.famen{
  width: 48%;
  background: url("@/assets/pengshui_22.png") no-repeat center center;
  background-size: 100% 100%;
  text-align: start;
}
.xiaofang{
  width: 48%;
  background: url("@/assets/pengshui_23.png") no-repeat center center;
  background-size: 100% 100%;
  text-align: start;
}
.font_icon{
  display: flex;
  width: 35%;
  justify-content: space-around;
  font-size: 14px;
  margin-left: 15%;
  height: 2.82vh;
  display: flex;
  align-items: flex-end;
  color: #649cff;
}
.yali_2{
  margin-left: 0.52vw;
  font-size: 10px;
  margin-left: 18%;
  height: 2.82vh;
  line-height: 1.5vh;
}
.yali_font{
  font-size: 8px !important;
  transform: scale(0.8);
}
.shuibiao_1{
  display: flex;
  width: 35%;
  justify-content: space-around;
  font-size: 14px;
  margin-left: 15%;
  margin-top: 8%;
  color: #649cff;
}
</style>